
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$icon.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$icon.js';
export default __default__;
